var React = require('react');

function K3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"K3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"17.75 48.39 60.27 1.17 0.52 0 0 26.63 17.75 48.39","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"5.22 12.83 4.32 80.57 35.68 80.99 66.88 81.4 5.22 12.83","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

K3.defaultProps = {"viewBox":"0 0 66.88 81.4"};

module.exports = K3;

K3.default = K3;
